// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"3dd87bea","708":"53010e08"}[chunkId] + ".chunk.js";
};